import { render } from "./AcademicGradeSelectorComponent.vue?vue&type=template&id=0b826ff2&scoped=true&ts=true"
import script from "./AcademicGradeSelectorComponent.vue?vue&type=script&lang=ts"
export * from "./AcademicGradeSelectorComponent.vue?vue&type=script&lang=ts"

import "./AcademicGradeSelectorComponent.vue?vue&type=style&index=0&id=0b826ff2&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b826ff2"]])

export default __exports__